import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Column } from '../grid/experimental.grid';

export interface FocusSelectorSortClosedForTeamGrid {
    column: Column;
}

export const focusSelectorSortClosedForTeamGrid = createAction<
    ActionType,
    FocusSelectorSortClosedForTeamGrid
>(ActionType.COACHING_FOCUS_SELECTOR__SORT_CLOSED_FOR_TEAM_GRID);
